import styled from "styled-components";

import { Title } from "@similarweb/ui-components";

import type { IBoxTitleProps } from "../../../components/BoxTitle/src/BoxTitle";
import { default as BoxTitle, InfoIcon } from "../../../components/BoxTitle/src/BoxTitle";

const StyledPrimaryTitle = styled(Title).attrs<{ "data-automation-box-title"?: boolean }>((props) => ({
    "data-automation-box-title": true,
}))`
    font-size: 20px;
    color: #2a3e52;
`;

StyledPrimaryTitle.displayName = "StyledPrimaryTitle";

const StyledSecondaryTitle = styled(Title).attrs<{ "data-automation-box-title"?: boolean }>((props) => ({
    "data-automation-box-title": true,
}))`
    font-size: 16px;
    color: #2a3e52;
    ${InfoIcon} {
        line-height: 1.55;
    }
`;

StyledSecondaryTitle.displayName = "StyledSecondaryTitle";

const PrimaryBoxTitle = (props: IBoxTitleProps) => (
    <StyledPrimaryTitle>
        <BoxTitle {...props} />
    </StyledPrimaryTitle>
);

const SecondaryBoxTitle = (props: IBoxTitleProps) => (
    <StyledSecondaryTitle>
        <BoxTitle {...props} />
    </StyledSecondaryTitle>
);

export { PrimaryBoxTitle, SecondaryBoxTitle, StyledPrimaryTitle };
